import React from 'react';
import { matchPath, useHistory, useLocation } from 'react-router-dom';
import { IconSource, Link } from '@clariness/clarikit-react';
import { NavBarItemLabel } from '../NavBarItemLabel/NavBarItemLabel';

type NavBarLinkProps = {
  to: string;
  icon: IconSource;
  label: string;
  onClick?: () => void;
};

export const NavBarLink: React.FC<NavBarLinkProps> = ({
  to,
  icon,
  label,
  onClick,
}) => {
  const history = useHistory();
  const location = useLocation();
  const isActive = Boolean(matchPath(location.pathname, { path: to }));
  const color = isActive ? 'color-green-primary' : 'color-gray-variant-1';

  return (
    <Link
      url={to}
      active={isActive}
      color={color}
      aria-label={label}
      onClick={(event: React.MouseEvent<HTMLAnchorElement>) => {
        event.preventDefault();
        onClick?.();
        history.push(to);
      }}
    >
      <NavBarItemLabel icon={icon} color={color} label={label} />
    </Link>
  );
};
